import React from 'react';
import KickImage from 'Reuseables/KickImage';
import styled from 'styled-components';
import propTypes from 'prop-types';

import {
  RaffleContentWrap,
  ContentTopBottom,
  ContentCenter,
  ButtonDone
} from './styled';

const HeaderText = styled.div`
  font-size: 1rem;
  text-align: center;
  text-transform: uppercase;
`;

const FooterText = styled.div`
  font-style: italic;
  text-align: center;
`;



const RaffleLoginBox = ({ headerText, onBtnLoginClick, footerText }) => (
  <RaffleContentWrap>
    <ContentTopBottom>
      <HeaderText>
        { headerText }
      </HeaderText>
    </ContentTopBottom>
    <ContentCenter>
      <ButtonDone onClick={onBtnLoginClick} primary>
        LOGIN 
      </ButtonDone>
    </ContentCenter>
    <ContentTopBottom>
      <FooterText>
        { footerText }
      </FooterText>
    </ContentTopBottom>
  </RaffleContentWrap>
)

export default RaffleLoginBox;

RaffleLoginBox.defaultProps = {

}

RaffleLoginBox.propTypes = {
  onBtnLoginClick: propTypes.func.isRequired,
  headerText: propTypes.oneOfType([propTypes.string, propTypes.node]),
  footerText: propTypes.oneOfType([propTypes.string, propTypes.node]),
}
